module.exports = __webpack_public_path__ + "img/author.d99cc698.png";